import * as React from 'react';

import { cn } from '../../lib/utils';

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-9 w-full rounded-md border border-[#3a5dd1] bg-[white] px-3 py-1 text-sm shadow-sm file:border-0 file:text-sm file:font-medium placeholder:text-[#A9A9A9] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
